import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { ViewboxOption } from 'src/app/models/viewboxOption.model';
import { NotificationService } from 'src/app/services/notification.service';
import { Subject } from 'rxjs';
import { IsomastersPagingComponent } from '../isomasters-paging/isomasters-paging.component';
import { OptionPage } from 'src/app/models/OptionPage.model';
import { ProductClass } from 'src/app/enums/productClass.enum';
import { ProductClassificationService } from 'src/app/services/product-classification.service';

@Component({
  selector: 'app-isomasters-horizontal-viewbox',
  templateUrl: './isomasters-horizontal-viewbox.component.html',
  styleUrls: ['./isomasters-horizontal-viewbox.component.scss'],
})
export class IsomastersHorizontalViewboxComponent implements OnDestroy {
  @Input() options: any[] = [];
  @Output() optionSelected$: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('hostElement') hostElement: ElementRef;
  @ViewChild('paging') paging: IsomastersPagingComponent;

  @Input() needsBorderedFlaredImage = false;
  @Input() bigImagesNoBorders = false;
  private unsubscribe: Subject<void> = new Subject();
  displayOptions: any[] = [];

  get hasOnlyOnePage() {
    return this.options?.length == this.displayOptions.length;
  }
  constructor(
    private host: ElementRef,
    private languageService: LanguageService,
    private notificationService: NotificationService,
    private cd: ChangeDetectorRef,
    private productClassificationService: ProductClassificationService
  ) {}
  get currentLocale() {
    return this.languageService.currentLanguage;
  }

  isNumber(value: any) {
    return typeof value === 'number';
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.unsubscribe();
  }

  get pagedOptions(): ViewboxOption<any>[] {
    return this.displayOptions;
  }

  showNotification(option: ViewboxOption<any>, element: HTMLElement) {
    if (element) {
      element.id = option.option;
    }

    this.notificationService.showBalloonNotification(option.description, element, null, false, 1);
  }

  hideNotification(option: ViewboxOption<any>) {
    this.notificationService.hideBalloonNotification(option.option);
  }

  getGoodLocation(element: HTMLElement): any {
    return element.offsetLeft - 30;
  }

  selectButton(option: any) {
    option.selected = true;
    this.optionSelected$.emit(option);
  }

  openLink(event: Event, link: string) {
    window.open(link);
    event.stopPropagation();
    event.preventDefault();
  }

  pageChanged(page: OptionPage) {
    this.displayOptions = page.pageItems;

    this.cd.detectChanges();
  }

  openClassification(event: Event, productClass: ProductClass) {
    this.productClassificationService.openClassificationURL(productClass);
  }
}
